module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_4-f5192ce1686898e9e7ed748b61cee10e.jpg";